import { useGenomeViewerStore } from "../../../store/store.ts";
import { SVG_STYLES } from "../settings.ts";

export function useAnchorPosition(groupId: string, scale: number) {
  const alignedFamily = useGenomeViewerStore((state) => state.alignedFamily);
  const basePerPixel = useGenomeViewerStore((state) => state.basePerPixel);
  const orthologousGroups = useGenomeViewerStore((state) => state.orthologousGroups);
  const tracks = useGenomeViewerStore((state) => state.tracks);

  const trackId = [...tracks.values()]
    .filter((track) => alignedFamily?.members.some((member) => member.trackId === track.trackId))
    .find((track) => track.groupId === groupId)?.trackId;

  const ortholog = orthologousGroups
    .find((group) => group.orthologId === alignedFamily?.familyId)
    ?.orthologs.find(
      (member) => member.id === alignedFamily?.members.find((member) => member.trackId === trackId)?.featureId,
    );

  return ortholog ? (ortholog.start / basePerPixel) * scale - SVG_STYLES.anchorPoint.width / 2 : undefined;
}
